import * as React from 'react';
import { styled } from '@mui/material/styles';
// import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import NoCrashIcon from '@mui/icons-material/NoCrash';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import StepperArrowLeft from './StepperArrowLeft';
import StepperArrowRight from './StepperArrowRight';
import '../styles/style.css'; // Ensure you have the correct path to your CSS file
import { Grid, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useWindowSize } from '../hooks/useWindowSize';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 18,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        'linear-gradient( 136deg, #003C59 0%, rgba(1, 184, 230, 1) 50%, #00C9DB 100%)',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        'linear-gradient( 136deg, #003C59 0%, rgba(1, 184, 230, 1) 50%, #00C9DB 100%)',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: '#eaeaf0',
    borderRadius: 1,
    ...theme.applyStyles('dark', {
      backgroundColor: theme.palette.grey[800],
    }),
  },
}));

const ColorlibStepIconRoot = styled('div')(({ theme }) => ({
  backgroundColor: '#ccc',
  zIndex: 1,
  color: '#fff',
  width: 40,
  height: 40,
  display: 'flex',
  borderRadius: '50%',
  justifyContent: 'center',
  alignItems: 'center',
  ...theme.applyStyles('dark', {
    backgroundColor: theme.palette.grey[700],
  }),
  variants: [
    {
      props: ({ ownerState }) => ownerState.active,
      style: {
        backgroundColor: '#00C9DB',
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
      },
    },
    {
      props: ({ ownerState }) => ownerState.completed,
      style: {
        backgroundColor: '#003C59'
      },
    },
  ],
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <CalendarMonthIcon />,
    2: <NoCrashIcon />,
    3: <ReceiptLongIcon />,
  };

  return (
    <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

export default function CustomStepper() {

    const location = useLocation();
    const { t } = useTranslation();
    const steps = [
        t("customStepper.step1"),
        t("customStepper.step2"),
        t("customStepper.step3")
    ];
    const navigate = useNavigate()
    const [activeStep, setActiveStep] = React.useState(0);
    const { isMobile } = useWindowSize();
    const draft = useSelector((state) => state.reservation.draft);

    let infoText = "";

    if (!draft.car && !draft.date) {
        infoText = t("infoForNext.noPlateOrDate");
    } else if (!draft.car) {
        infoText = t("infoForNext.noPlate");
    } else if (!draft.date) {
        infoText = t("infoForNext.noDate");
    } else if (!draft.services || draft.services.length === 0) {
        infoText = t("infoForNext.noSelectedServices");
    }

    const isStepFailed = (step) => {
      return !isMobile && step === 0 && infoText !== "";
    };

    const handleLeftArrowClick = () => {
        if (activeStep === 0) {
            navigate("/workshoplist")
        } else if (activeStep === 1) {
            navigate(`${location.pathname}?step=1`)
        } else if (activeStep === 2) {
            navigate(`${location.pathname}?step=2`)
        }
    };

    React.useEffect(() => {
        if (location.pathname.startsWith("/reservations")) {
            setActiveStep(5);
        } else {
            const params = new URLSearchParams(location.search);
            setActiveStep(Number(params.get('step')) - 1);
        }
    }, [location]);

    return (
        <Grid container spacing={1} className="custom-stepper-container" >
          <StepperArrowLeft handleClick={handleLeftArrowClick}/>
          <Grid item size={{xs: 10, sm: 10, md: 10, lg: 10}} className="custom-stepper">
              <Stepper activeStep={activeStep} alternativeLabel connector={<ColorlibConnector />} >
                {steps.map((label, index) => {
                  const labelProps = {};
                  if (index === 0 && isStepFailed(activeStep)) {
                    labelProps.optional = (
                      <Typography variant="caption" color="error" >                        
                        {infoText}
                      </Typography>
                    );

                    labelProps.error = true;
                  }

                  return (
                    <Step key={label} >
                      <StepLabel {...labelProps} slots={{ stepIcon: ColorlibStepIcon }} 
                      sx={{
                        "& .MuiStepLabel-labelContainer": {
                          marginTop: "-10px",
                        },
                      }}
                      >
                        {label}
                      </StepLabel>
                    </Step>
                  );
                })}
              </Stepper>
          </Grid>
          <StepperArrowRight />
        </Grid>
    );
}